import PickStore from 'components/HappeningNonContent/ServiceBooking/PickStore/PickStore';

export default PickStore;
